import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {}

    canActivate(): boolean | UrlTree {
        if (this.authService.isLoggedIn()) {
        return true; // Tiene token, le dejamos pasar
        }

        // No tiene token, lo redirigimos al login
        return this.router.createUrlTree(['/login']);
    }
}